// test2620
(2620 && 0);
